/**
 * Web-side mirror of apps/api/src/bots/bot-ids.ts.
 *
 * The web bundle can't import the API package directly, so the bot
 * registry is duplicated here. Keep these two lists aligned — the
 * controller passes bot user ids through as opaque strings, so a
 * mismatch shows up as the user-id prefix in the UI rather than a
 * pretty display name. New bots: add to both files.
 */

type BotProfile = { userId: string; displayName: string };

export const BOT_PROFILES: readonly BotProfile[] = [
  { userId: 'bot_random_v1', displayName: 'Random Bot' },
  { userId: 'bot_card_v1', displayName: 'Card-Play Bot' },
];

const BY_ID = new Map<string, BotProfile>(BOT_PROFILES.map((b) => [b.userId, b] as const));

export function isBotUserId(userId: string | null | undefined): boolean {
  if (!userId) return false;
  return userId.startsWith('bot_');
}

export function getBotDisplayName(userId: string): string | undefined {
  return BY_ID.get(userId)?.displayName;
}
